/* Imports */
import React from 'react'

/* Functional Component */
function Star(props) {
  return (
    <props.icon className='mx-1 text-xl text-teal-500' />
  )
}

/* Exports */
export default Star